import { Fragment, h } from "preact";
import React from "react";
import { setGoogleAnalytics } from "../../functions/GAReact";
import { env } from "../../utils/env/config";

export default (routeName: string) => (Wrap: any) => {
  class WrapperComponent extends React.Component {
    constructor(props: any) {
      super(props);
    }

    async componentDidMount() {
      switch (env.node) {
        case "development":
          console.log("PATH ===>", routeName);
          break;
        case "production":
          const { location } = window;
          const pathname = location.pathname;
          const ga = await setGoogleAnalytics();
          ga && ga.pageView(pathname, routeName, document.title);
          break;
      }
    }
    render() {
      return (
        <>
          <Wrap {...this.props} />
        </>
      ) as React.ReactNode;
    }
  }
  return WrapperComponent;
};
